import { useMemo } from 'react'
import {
  useGetWorkspaceUsage,
  useInvalidateWorkspaceUsage
} from '@/queries/workspaceQueries'
import { FeatureKey } from '@/types/subscription'

export const useFeatureUsage = (feature: FeatureKey) => {
  const { data } = useGetWorkspaceUsage()

  const { invalidateWorkspaceUsage } = useInvalidateWorkspaceUsage()

  const usage = data?.[feature]

  const returnValue = useMemo(() => {
    return {
      usage,
      refreshFeatureUsage: invalidateWorkspaceUsage
    }
  }, [usage, invalidateWorkspaceUsage])

  return returnValue
}
